import { render, staticRenderFns } from "./Warenkorb.vue?vue&type=template&id=24b27d25&scoped=true"
import script from "./Warenkorb.vue?vue&type=script&lang=js"
export * from "./Warenkorb.vue?vue&type=script&lang=js"
import style0 from "./Warenkorb.vue?vue&type=style&index=0&id=24b27d25&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b27d25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b27d25')) {
      api.createRecord('24b27d25', component.options)
    } else {
      api.reload('24b27d25', component.options)
    }
    module.hot.accept("./Warenkorb.vue?vue&type=template&id=24b27d25&scoped=true", function () {
      api.rerender('24b27d25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Warenkorb.vue"
export default component.exports